<ng-content></ng-content>
<iframe *ngIf="srcUrl"
        [src]="srcUrl | safeHtml:'resourceUrl'"
        frameborder="0"
        height="100%"
        width="100%"></iframe>
<nb-alert *ngIf="error" status="danger">{{error}}</nb-alert>
